import { ResourceOptions } from 'react-admin';
import { MdOutlineCallMade } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayWithdrawals;
export {
  XBIT_RELAY_WITHDRAWALS_PERMISSION_RESOURCE,
  XBIT_RELAY_WITHDRAWALS_READ_ACTION,
  XBIT_RELAY_WITHDRAWALS_APPROVE_ACTION,
} from './constants';
export const icon = MdOutlineCallMade;
export const options: ResourceOptions = {
  label: 'module.xbitRelayWithdrawals.title',
};
